<template>
    <li class="item">
        <a class="item__link">
            <div class="item__col-left">
                <h3 class="item__title">
                    {{ title }}<slot name="title" />
                </h3>
                <div v-if="$slots.id"
                     class="item__id"
                >
                    <slot name="id" />
                </div>
                <div class="item__desc">
                    <slot />
                </div>
            </div>
            <div v-if="$slots['right-title'] || $slots['right-desc']"
                 class="item__col-right"
            >
                <div class="item__title">
                    <slot name="right-title" />
                </div>
                <div class="item__desc">
                    <slot name="right-desc" />
                </div>
            </div>
        </a>
    </li>
</template>

<script>
import '@/assets/icons/chevron-right.svg';

export default {
    name: 'ScrollViewItem',
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
    },
};
</script>

<style scoped lang="scss">
.item {
    $_this: &;

    position: relative;
    margin: 0;
    padding: 0;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        right: $page-padding-sides-mobile/2;
        left: $page-padding-sides-mobile/2;
        height: 1px;
        background-color: $color-separator;
    }

    &:first-child {
        &::before {
            display: none;
        }
    }

    &__title {
        margin: 0;
        transition: $transition-quick;
        transition-property: color;
        color: $color-text-bright;
        font-size: 15px;
        font-weight: 500;
        letter-spacing: $letter-spacing-sm;
        line-height: 1.25;
        text-transform: none;
    }

    &__id,
    &__desc {
        margin: 2px 0 0;
        font-size: 13px;
        font-weight: 400;
        letter-spacing: $letter-spacing-xs;
    }

    &__col-left {
        margin-right: auto;
    }

    &__col-right {
        text-align: right;
    }

    &__link {
        display: flex;
        position: relative;
        z-index: 1;
        align-items: center;
        padding: 13px ($page-padding-sides-mobile - 2) 12px;
        border: 2px solid transparent; // for focus
        color: $color-text-heading-2;
        text-decoration: none;

        &:hover,
        &:focus {
            #{$_this}__title {
                color: $color-button-hover;
            }
        }

        &:focus {
            @include input-box-focus;
        }
    }
}
</style>
